import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { plainToInstance } from 'class-transformer'
import { FeeItemInstance } from '../model/fee-item.model'
import { ScopeSection } from '../model/scope-section'

export const mapScopeFee = (
  feeItem: FeeItemInstance,
  parent: {
    scopeSection?: ScopeSection
    deliverable?: Deliverable
    component?: ScopeComponent
  } = {}
): FeeItemInstance =>
  plainToInstance(FeeItemInstance, {
    ...feeItem,
    scopeSection: plainToInstance(ScopeSection, parent.scopeSection),
    deliverable: plainToInstance(Deliverable, parent.deliverable),
    component: plainToInstance(ScopeComponent, parent.component),
  })
